import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-operation-download",
  "use": "icon-operation-download-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-operation-download\"><path d=\"M768 640v128H256v-128H170.666667v128c0 46.933333 38.4 85.333333 85.333333 85.333333h512c46.933333 0 85.333333-38.4 85.333333-85.333333v-128h-85.333333z m-42.666667-170.666667l-60.16-60.16L554.666667 519.253333V170.666667h-85.333334v348.586666L358.826667 409.173333 298.666667 469.333333l213.333333 213.333334 213.333333-213.333334z\" p-id=\"1012\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol